export default __webpack_public_path__ + "static/media/not_found.0424d704.png";